import { forwardRef } from "react";
function SvgInfoIconRaw({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <circle cx={12} cy={12} r={9} stroke="#1D1D1D" strokeWidth={2} />
      <path
        stroke="#1D1D1D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 7v.02M12 11v6"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgInfoIconRaw);
export default ForwardRef;
